import React from 'react';
import styled from 'styled-components';
import {theme} from '../../themes/default-theme';
import {Grid, Box} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import Banner from '../../components/multimedia/Banner';
import {Cta, Links, RespImg} from '../../components/ui';
import chevronLeft from '../../assets/icons/chevron-left-white.svg';
import dlPush from '../../util/dlPush';


const TopWrapper = styled.div`
  background-color: ${theme.palette.white};
  padding: 30px 0;

  ${theme.breakpoints.up('md')} {
    padding: 60px 0;
  }
  ${theme.breakpoints.up('lg')} {
    padding: 120px 0;
  }
`

const PageContainer = styled.div`
  max-width: 1400px;
  font-weight: 700;
  margin: 0 auto;
  & .hide-for-large {
    ${theme.breakpoints.up('md')} {
      display: none;
    }
  }
  & .hide-for-small {
    ${theme.breakpoints.down('sm')} {
      display: none;
    }
  }
`

const ReturnLink = styled(Grid)`
	margin-top: 20px !important;
  padding-left: 30px;
  
  ${theme.breakpoints.down('sm')} {
		padding-left: 13px;
	}
` 

const ClubTitle = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: ${theme.palette.charcoal};

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
` 

const ClubDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${theme.palette.gunmentalGrey};
  margin-bottom: 26px;

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
` 

const StaffTable = styled.div`
  font-size: 16px;
  font-weight: 400;
  & div:first-child {
    color: ${theme.palette.charcoal};
    float: left;
    min-width: 200px;
  }
  & div:last-child {
    color: ${theme.palette.gunmentalGrey};
  }

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
    & div:first-child {
      min-width: auto;
      width: 50%;
    }
  }
` 

const ClubActivity = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: ${theme.palette.charcoal};
  margin-top: 26px;
  margin-bottom: 14px;

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
    margin-bottom: 5px;
  }
` 

const ActivityListing = styled.li`
  font-size: 16px;
  font-weight: 400;

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
` 

const ImageContainer = styled.div`
  border-bottom-right-radius: 80px;
  overflow: hidden;

  ${theme.breakpoints.down('sm')} {
    border-bottom-right-radius: 40px;
    margin-bottom: 20px;
  }
` 

const CtaContainer = styled.div`
	display: inline-block;
  margin-right: 30px;
  
  ${theme.breakpoints.up('lg')} {
    max-width: 263px;
    width: 100%;
  }

	${theme.breakpoints.down('sm')} {
		display: block;
		margin: 0;
		margin-bottom: 10px;
	}

`

const ClubPage = (props) => {

  const sendEvent = (url) => {
    dlPush({
      'event': 'jaycoEvent',
      'eventAction': 'External Link Click',
      'eventCategory': 'Owners Club',
      'eventLabel': url  
    })
  }

  return (
    <div>
      {props.heroBanner &&
				<Banner
          {...props.heroBanner}
					type="mediumBanner"
				/>
      }
      <ReturnLink container className={'hasPadding'} spacing={0} direction={'row'} align={'left'}>
				<Grid item xs={12}>
					<Box>
						<Typography>
							<Links href="/owners-clubs" svg={chevronLeft}>
								Go back
							</Links>
						</Typography>
					</Box>
				</Grid>
			</ReturnLink>
		  <TopWrapper>
        <PageContainer>
          <Grid container className={'hasPadding'} spacing={0} direction={'row'} wrap="wrap">
            <Grid item xs={12} md={6}>
              {(props.title || props.description) &&
                <Box px={2}>
                  {props.title && <ClubTitle dangerouslySetInnerHTML={{ __html: props.title }} />}
                  {props.description && <ClubDescription dangerouslySetInnerHTML={{ __html: props.description }} />}
                </Box>
              }
              {props.clubImage &&
                <Box className={'hide-for-large'}>
                  <ImageContainer>
                    <RespImg
                      {...props.clubImage}
                    />
                  </ImageContainer>
                </Box>
              }
              {props.positions &&
                <Box px={2}>
                  {props.positions.map(function(staff, index) {
                    return (
                      <StaffTable key={index}>
                        <div>{staff.ownStaffPosition}:</div>
                        <div>{staff.ownStaffName}</div>
                      </StaffTable>
                    )
                  })}
                </Box>
              }
              {props.activities &&
                <Box px={2}>
                  <ClubActivity>Club activities:</ClubActivity>
                  <ul>
                    {props.activities.map(function(activity, index) {
                      return (
                        <ActivityListing key={index}>{activity.ownClubActivity}</ActivityListing>
                      )
                    })}
                  </ul>
                </Box>
              }
              {props.ctas &&
                <Box px={2}>
                  {props.ctas.map(function(cta, index) {
                    return (
                      <CtaContainer key={index}>
                        {cta.ownClubCtaLink && 
                        <Cta 
                          href={cta.ownClubCtaLink.url} 
                          target={cta.ownClubCtaLink.target}
                          onClick={() => sendEvent(cta.ownClubCtaLink.url)}
                        >
                          {cta.ownClubCtaLink.title}
                        </Cta>
                        }
                      </CtaContainer>
                    )
                  })}
                  <CtaContainer>
                    <Cta 
                      href={'/owners-clubs'} 
                      onClick={() => sendEvent('/owners-clubs')}
                      outline={true}
                    >
                      Back to search
                    </Cta>
                  </CtaContainer>
                </Box>
              }
            </Grid>
            {props.clubImage &&
              <Grid className={'hide-for-small'} item xs={12} md={6}>
                <Box px={2}>
                  <ImageContainer>
                    <RespImg
                      {...props.clubImage}
                    />
                  </ImageContainer>
                </Box>
              </Grid>
            }
          </Grid>
        </PageContainer>
      </TopWrapper>
    </div>
  )
}

export default ClubPage